import { Match } from 'found';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { fetchCollections } from '../actions/collections.actions';
import withAsyncData from '../components/utils/withAsyncData';
import { StoreType } from '../reducers';
import { selectOwnCollections, selectOwnCollectionStatus } from '../reducers/collections.selectors';
import { CollectionProperties } from '../types/AppContent';
import { AsyncActionStatus } from '../actions/common.actionTypes';
import MyCollections from '../components/MyCollections';

interface StateProps {
  collections: CollectionProperties[];
  collectionsStatus: AsyncActionStatus;
}

type OwnListPageProps = Match & StateProps;

const OwnCollectionListPage: React.FC<OwnListPageProps> = ({ collections, collectionsStatus: collectionStatus }) => {
  return (
    <MyCollections
      collectionsStatus={collectionStatus}
      collections={collections}
    />
  );

};

const mapState = (state: StoreType): StateProps => ({
  collections: selectOwnCollections(state),
  collectionsStatus: selectOwnCollectionStatus(state),
});

export default compose<React.FC<Record<string,never>>>(
  connect(
    mapState,
    { fetchCollections },
  ),
  withAsyncData((props) => ({
    refetch: () => props.fetchCollections(),
    dataProp: 'collections',
    statusProp: 'collectionsStatus',
  })),
)(OwnCollectionListPage);
